var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _path21, _ellipse2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse3, _path31, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWhenToDoCs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 609 627",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "0%",
    x2: "100.006%",
    y1: "49.997%",
    y2: "49.997%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "0%",
    x2: "100.008%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3F6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58%",
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M10.091 534.828h6.022c11.32.002 22.44-2.99 32.231-8.671L379.63 333.983c1.218-.707 1.96-2.016 1.942-3.424-.019-1.408-.796-2.696-2.033-3.37l-16.477-8.99v7.727c-.007 2.839-1.525 5.46-3.984 6.879L10.09 534.828z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M608.801 460.572L366.077 626.676 178.391 536.108 421.121 370.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M440.045 101.68L177.56 251.972 0.359 145.9 251.403 0.057z",
    opacity: 0.3,
    transform: "translate(162.21 336.828)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "nonzero",
    d: "M594.099 434.684L339.771 582.427 159.29 478.261 413.613 330.512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M415.839 386.771L410.927 389.628 373.778 368.189 378.696 365.338zM488.668 466.666L483.757 469.516 371.581 404.773 376.493 401.917zM463.255 402.253L458.349 405.103 384.051 362.221 388.963 359.37zM422.31 440.26L417.398 443.11 361.313 410.736 366.22 407.886z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    d: "M85.158.097l21.804 12.585L85.3 25.268 63.495 12.682 85.158.097zm.136 23.771l19.255-11.186L85.197 1.496 65.943 12.682l19.351 11.186",
    transform: "translate(264.09 382.345)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    d: "M96.137 13.416L96.336 15.061 78.607 15.732 77.565 10.184 80.399 10.014 81.139 13.985z",
    transform: "translate(264.09 382.345)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    d: "M53.467 18.508L75.27 31.094 53.61 43.674l-21.804-12.58 21.662-12.586zm.136 23.772l19.25-11.186L53.5 19.914 34.246 31.1l19.352 11.186",
    transform: "translate(264.09 382.345)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    d: "M64.446 31.822L64.645 33.472 46.916 34.144 45.874 28.596 48.709 28.426 49.449 32.391z",
    transform: "translate(264.09 382.345)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    d: "M22.197 36.687l21.805 12.58-21.663 12.585L.535 49.267l21.662-12.58zm.131 23.771l19.22-11.191-19.35-11.18L2.93 49.272l19.38 11.186",
    transform: "translate(264.09 382.345)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M390.625 458.666L385.708 461.522 329.617 429.148 334.535 426.297zM425.691 503.25L420.779 506.106 308.598 441.358 313.51 438.507zM359.333 476.844L354.421 479.695 298.33 447.326 303.242 444.47zM327.238 495.489L322.332 498.34 266.241 465.966 271.153 463.115z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M262.331 498.363L257.425 501.213 229.377 485.026 234.289 482.176z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M393.596 521.895L388.684 524.746 276.509 460.003 281.421 457.152zM456.978 485.072L452.072 487.928 339.89 423.179 344.802 420.329z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M265.16 450.991L265.353 452.635 247.624 453.312 246.588 447.759 249.417 447.588 250.157 451.559z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M254.175 437.671l21.804 12.586-21.662 12.585-21.804-12.585 21.662-12.586zm.137 23.771l19.254-11.185-19.351-11.186-19.255 11.186 19.352 11.174"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M523.302 436.903c3.79 2.19 3.807 5.735.045 7.926-3.762 2.19-9.892 2.19-13.66 0-3.767-2.19-3.807-5.736-.04-7.92 3.768-2.185 9.864-2.19 13.655-.006z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    d: "M362.372 77.948L5.316 284l.706 247.933c0 2.896 2.06 4.068 4.553 2.611l347.927-200.81c2.521-1.457 4.553-4.985 4.553-7.88l-.683-247.905z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F7",
    fillRule: "nonzero",
    d: "M295.49.569l5.214 3.027c-.831-.484-1.975-.415-3.244.318L292.24.882c1.27-.706 2.42-.774 3.25-.313z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M6.352 533.94L1.138 530.811 0.427 280.967 5.64 283.999z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M5.64 283.999L.427 280.972.381 263.863 5.595 266.896zM10.148 259.016L4.935 255.983 352.856 55.178 358.075 58.205z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M5.595 266.89L.38 263.863c0-2.89 2.032-6.423 4.554-7.88l5.213 3.033C7.627 260.472 5.59 264 5.595 266.89z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M358.12 58.205c2.522-1.456 4.554-.284 4.554 2.612l.045 17.103L5.692 284l-.052-17.11c0-2.89 2.032-6.418 4.554-7.874L358.12 58.206z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M39.403 250.663c1.6-.921 2.897-.182 2.903 1.656-.108 2.028-1.181 3.88-2.886 4.984-1.594.922-2.891.182-2.897-1.65.106-2.028 1.177-3.882 2.88-4.99zM28.987 256.677c1.594-.921 2.892-.182 2.897 1.65-.098 2.025-1.16 3.88-2.857 4.99-1.594.922-2.891.182-2.897-1.65.099-2.024 1.16-3.88 2.857-4.99zM18.572 262.686c1.599-.922 2.897-.182 2.902 1.655-.111 2.028-1.183 3.882-2.885 4.99-1.594.916-2.892.177-2.897-1.655.105-2.029 1.176-3.884 2.88-4.99z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M80.991 277.467L81.008 283.146 43.865 304.584 43.848 298.906z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M287.454 196.35l52.408-30.246c.188 2.765.307 22.832.393 49.25l-52.659 30.394-.142-49.398z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M74.588 417.689l52.408-30.223c.188 2.765.308 22.838.393 49.255l-52.658 30.366-.143-49.398z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.964,
    cy: 423.623,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 80.964 423.623)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M180.873 207.03l52.408-30.252c.182 2.765.307 22.838.387 49.255l-52.675 30.388-.12-49.392z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.24,
    cy: 212.96,
    fill: "#6CEAC0",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 187.24 212.96)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M195.933 223.717L220.976 209.368M195.933 229.515L205.17 224.218"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M189.962 224.218L191.807 225.333 189.974 226.391z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M189.382 224.354v2.709c0 .188.13.261.29.17l2.277-1.325v6.901c-.01.205-.118.392-.29.501l-5.931 3.414c-.165.097-.296 0-.296-.165v-9.61c.013-.206.123-.394.296-.506l3.654-2.089z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M89.648 434.382L114.691 420.033M89.648 440.18L98.891 434.883"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M83.683 434.883L85.522 435.993 83.689 437.057z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M83.097 435.02v2.708c0 .188.131.262.296.17l2.277-1.325v6.901c-.007.204-.113.391-.285.501l-5.936 3.414c-.165.097-.296 0-.296-.165v-9.61c.011-.206.121-.395.296-.506l3.648-2.088z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M181.59 306.485l52.408-30.252c.188 2.765.308 22.838.393 49.255l-52.659 30.389-.142-49.392zM74.588 317.864l52.408-30.252c.188 2.765.308 22.838.393 49.255l-52.658 30.389-.143-49.392z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M118.106 244.154L118.123 249.833 43.831 292.71 43.814 287.037z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M233.924 325.676l52.408-30.246c.188 2.765.313 22.838.393 49.25l-52.658 30.393-.143-49.397z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.191,
    cy: 303.343,
    fill: "#6A8AEB",
    fillRule: "nonzero",
    rx: 11.153,
    ry: 6.459,
    transform: "rotate(-59.84 30.191 303.343)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M287.425 344.901v-49.5l52.761-30.45.12 40.913c0 4.677-3.29 10.39-7.36 12.74l-45.52 26.297zM287.368 245.281L339.873 214.984 339.873 215.211 340.01 264.603 340.01 264.836 287.425 295.196 287.226 295.31 287.084 245.452zM287.021 345.134L287.067 308.174 287.01 295.43 234.351 325.824 233.947 326.057 181.283 356.451 180.953 356.645 181.294 406.15 287.22 345.015zM287.368 245.048c0-17.16-.057-34.309-.102-49.415l52.63-30.371.137 49.392-52.665 30.394zM234.351 325.59c0-15.128 0-32.277-.045-49.448l52.658-30.394c0 17.16.04 34.331.046 49.448l-52.659 30.395zM332.389 119.66c4.07-2.35 7.399-.456 7.399 4.215l.114 40.92-52.636 30.36c-.086-26.286-.205-46.29-.387-49.255l45.51-26.24zM181.283 356.218c0-15.129 0-32.283-.046-49.449l52.687-30.394c0 17.16.034 34.331.046 49.449l-52.687 30.394zM234.306 275.675c0-17.16-.057-34.308-.103-49.414l52.653-30.395c.046 15.106.08 32.255.103 49.415l-52.653 30.394zM128.231 436.778v-49.466l52.66-30.394v49.466l-52.66 30.394zM233.81 176.544l52.659-30.394c.188 2.765.307 22.838.393 49.256L234.197 225.8c-.08-26.287-.204-46.291-.387-49.256zM181.237 306.303c0-17.16-.057-34.309-.102-49.415l52.664-30.394c.046 15.106.08 32.254.103 49.414l-52.665 30.395zM128.22 386.845c0-15.128 0-32.283-.045-49.448l52.658-30.4c0 17.165.04 34.331.046 49.454l-52.659 30.394zM74.93 417.621L127.731 387.147 127.731 387.613 127.827 421.848 127.867 437.011 75.163 467.428zM180.742 207.172l52.664-30.394c.188 2.765.308 22.838.393 49.25l-52.664 30.4c-.08-26.287-.205-46.292-.393-49.256zM75.02 417.547l-.141-49.398 52.891-30.525c0 17.166.035 34.332.046 49.449l-52.795 30.474zM23.114 488.952l-.12-40.914 51.628-29.791.137 49.391-44.24 25.536c-4.07 2.35-7.394.455-7.405-4.222zM127.936 237.651l52.408-30.246c.182 2.765.307 22.838.387 49.25l-52.67 30.394-.125-49.398zM74.879 367.688l-.137-49.392 52.932-30.547c.045 15.106.08 32.254.102 49.414L74.88 367.688zM22.994 447.571L22.857 398.179 74.48 368.382 74.617 417.78zM22.852 397.713L22.715 348.321 74.338 318.53 74.48 367.922z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.004,
    cy: 322.355,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 81.004 322.355)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.308,
    cy: 331.609,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 240.308 331.61)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.261,
    cy: 318.086,
    fill: "#6A8AEB",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 88.261 318.086)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.122,
    cy: 200.33,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 295.122 200.33)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.254,
    cy: 311.57,
    fill: "#6A8AEB",
    fillRule: "nonzero",
    rx: 3.522,
    ry: 2.043,
    transform: "rotate(-59.84 188.254 311.57)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M248.996 342.369L274.039 328.02M248.996 348.161L258.239 342.87M83.313 335.257L116.41 316.294M83.313 342.762L113.325 325.568M83.313 350.301L100.61 340.389M190.253 322.786L223.355 303.822M190.253 330.29L220.27 313.09M190.253 337.829L207.549 327.918M296.543 213.146L329.64 194.182M296.543 220.651L326.555 203.456M296.543 228.189L313.84 218.284"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M120.041 299.037c.61-.353.655-.273.66.438 0 .341 0 .341.29.222.304-.124.625-.2.951-.228.217-.034.325.171.25.45l-.062.284c-.045.245-.097.478-.16.717-.02.214-.132.41-.307.535-.08.045-.17.069-.261.068-.424.024-.835.153-1.196.376l-.17.102c-.123.075-.235.165-.336.268-.15.156-.25.354-.285.569 0 .182.057.313.182.341.184.057.378.074.57.051h.136c.344-.044.69-.063 1.036-.057.607.049 1.09.53 1.138 1.138.092.787-.066 1.583-.45 2.276-.296.599-.703 1.136-1.2 1.582-.117.078-.184.212-.177.353v.762c-.025.259-.165.492-.381.637l-.381.216-.302.177h-.046c-.216.114-.387 0-.375-.268v-.529c.011-.077.011-.156 0-.233-.067.016-.132.039-.194.068-.377.163-.78.261-1.19.29-.34 0-.403-.113-.307-.569.063-.295.12-.569.188-.881.028-.225.142-.429.319-.57.081-.045.175-.064.267-.056.426-.006.846-.105 1.23-.29.07-.026.136-.058.199-.097.21-.124.402-.277.57-.455.109-.107.196-.235.255-.376.16-.358.097-.694-.136-.74-.143-.046-.294-.063-.444-.05l-.404.04c-.303.046-.61.06-.917.039-.796-.091-1.138-.57-1.138-1.525.089-1.183.628-2.287 1.508-3.084.256-.256.256-.256.256-.569v-.426c-.035-.34.151-.662.461-.803l.353-.193zM224.954 287.897c.61-.348.66-.274.66.443 0 .336 0 .336.297.222.3-.126.62-.203.944-.227.222-.034.325.17.25.45l-.056.278c-.051.245-.103.478-.165.717-.02.216-.132.413-.308.54-.079.046-.17.07-.261.069-.424.023-.835.152-1.196.375-.059.03-.116.064-.17.103-.123.075-.235.165-.336.267-.152.155-.252.354-.285.569 0 .182.057.319.182.347.184.058.379.073.57.046h.136c.343-.047.69-.066 1.036-.057.608.048 1.09.53 1.138 1.138.094.787-.063 1.583-.45 2.275-.294.597-.7 1.132-1.195 1.576-.119.08-.188.216-.182.359v.75c-.024.259-.164.491-.381.632l-.376.222-.307.171-.046.029c-.216.108-.387 0-.37-.274v-.506c.012-.075.012-.152 0-.228-.064.014-.127.035-.187.063-.379.166-.783.267-1.196.296-.341 0-.404-.12-.307-.598l.194-.881c.022-.225.135-.43.313-.57.082-.042.175-.06.267-.05.426-.01.845-.108 1.23-.29.069-.03.135-.063.199-.103.213-.12.405-.274.569-.455.11-.105.196-.231.256-.37.16-.364.103-.694-.137-.746-.143-.046-.294-.063-.443-.05l-.405.045c-.303.045-.61.056-.916.034-.797-.085-1.167-.569-1.138-1.52.087-1.183.627-2.287 1.508-3.083.256-.262.256-.262.256-.569v-.432c-.036-.338.15-.66.461-.797l.347-.21zM331.057 177.62c.609-.347.654-.273.66.443 0 .336 0 .336.29.222.303-.126.624-.203.95-.227.217-.034.325.165.251.45l-.062.278c-.051.245-.103.478-.16.717-.023.216-.136.413-.313.54-.078.043-.166.066-.256.069-.425.022-.838.151-1.2.375l-.166.103c-.122.075-.235.165-.336.267-.152.155-.251.354-.284.569 0 .182.057.319.176.347.185.054.379.07.57.046h.136c.343-.047.69-.066 1.036-.057.609.046 1.092.53 1.138 1.138.096.786-.06 1.583-.444 2.276-.295.597-.702 1.133-1.2 1.576-.117.081-.183.216-.177.358v.649c.006.022.006.046 0 .068-.02.258-.158.491-.376.631l-.381.222-.302.171-.045.028c-.222.109-.387 0-.376-.273v-.506c.009-.076.009-.152 0-.228-.066.014-.131.035-.193.063-.377.167-.78.267-1.19.296-.341 0-.404-.12-.307-.598.057-.29.12-.569.188-.881.027-.225.141-.429.318-.57.08-.043.172-.06.262-.05.428-.01.848-.108 1.235-.29l.2-.103c.211-.122.403-.276.569-.455.106-.108.192-.233.256-.37.159-.364.096-.694-.137-.746-.143-.046-.294-.063-.444-.05l-.404.04c-.305.049-.614.062-.922.039-.791-.085-1.138-.57-1.138-1.52.087-1.183.627-2.287 1.508-3.083.256-.262.256-.262.256-.569v-.427c-.033-.338.152-.66.461-.802l.353-.176z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M339.15 607.086c-.933.002-1.831-.35-2.515-.984l-95.619-88.44c-1.473-1.393-1.55-3.712-.173-5.2 1.377-1.487 3.696-1.589 5.199-.228l95.618 88.44c1.117 1.033 1.487 2.645.932 4.062-.554 1.416-1.92 2.349-3.442 2.35z",
    opacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M243.031 342.87L244.875 343.979 243.037 345.038z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M242.462 343.007v2.702c0 .188.136.268.296.17l2.276-1.325v6.907c-.013.203-.12.388-.29.501l-5.936 3.414c-.165.097-.296 0-.296-.165l-.029-9.61c.012-.207.122-.395.296-.506l3.683-2.088zM331.085 599.388c-.93.002-1.828-.35-2.51-.984l-95.618-88.44c-.987-.894-1.417-2.248-1.127-3.547.29-1.299 1.255-2.341 2.528-2.73 1.273-.39 2.657-.066 3.624.849l95.62 88.44c1.117 1.034 1.486 2.647.93 4.064-.556 1.417-1.924 2.35-3.447 2.348z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M172.467 576.556L115.608 610.142 56.916 576.265 113.775 542.685zM228.233 471.177c1.2.734 1.11.894-.148 1.576-.598.33-.598.33-.108.734.505.413.945.9 1.303 1.446.273.358 0 .74-.57.876l-.568.16c-.478.147-.94.278-1.418.403-.401.165-.854.153-1.246-.034-.153-.096-.278-.229-.364-.387-.445-.726-1.066-1.328-1.805-1.752l-.341-.2c-.25-.144-.518-.257-.797-.335-.405-.128-.84-.128-1.246 0-.336.153-.501.398-.439.643.078.384.238.746.467 1.064l.16.227c.406.559.767 1.149 1.08 1.764.53 1.081.206 2.213-.87 3.107-1.296.914-2.847 1.398-4.434 1.382-1.335.049-2.668-.156-3.927-.603-.246-.142-.55-.142-.797 0l-.825.45-.398.221-.114.057c-.479.207-1.026.184-1.486-.062l-.74-.455-.569-.37-.09-.051c-.405-.285-.354-.695.119-.922l.888-.484c.14-.067.272-.151.392-.25-.09-.102-.19-.194-.301-.273-.65-.51-1.207-1.125-1.65-1.82-.337-.598-.183-.826.756-1.139.57-.17 1.138-.347 1.708-.506.414-.17.878-.17 1.292 0 .155.1.276.245.347.415.425.748 1.007 1.395 1.707 1.895.117.094.24.18.37.256.417.251.867.443 1.338.569.293.086.6.12.905.097.785-.069 1.314-.49 1.172-.95-.05-.298-.162-.581-.33-.831-.148-.228-.302-.45-.461-.672-.37-.492-.686-1.023-.945-1.581-.603-1.491-.074-2.612 1.617-3.414 1.997-.956 4.314-1.059 6.875-.29.706.21.706.21 1.23-.074l.267-.148.49-.268c.563-.38 1.305-.362 1.85.046l.654.483z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhenToDoCs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/when-to-do-cs.81feee1f.svg";
export { ForwardRef as ReactComponent };